// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3Jvl1","itemTitle":"ClientEmergencyInfo_itemTitle__3tnWA","itemText":"ClientEmergencyInfo_itemText___wkm4"};